<i18n>
{
  "de": {
    "welcome_text": "Willkommen im Bewohnerportal! Bitte wähle einen Nutzername sowie ein sicheres Passwort für deinen Account. Dein Benutzername wird für die Anmeldung hier sowie zum Beispiel im Forum (\"Community\") verwendet."
  },
  "en": {
    "welcome_text": "Welcome! Please choose a username and a secure password. The username is used for this portal as well as other services such as the forum (\"Community\")."
  }
}
</i18n>
<template>
    <div class="pw_reset">
        <loading :data="[token_valid]">
            <b-jumbotron :header="$t('system.set_new_password')" v-if="token_valid">
                <b-alert variant="info" v-if="!username_set">{{$t('welcome_text')}}</b-alert>
                <b-form @submit="reset_pw">
                    <div class="pull-left logincont">
                        <template v-if="!username_set">
                            <label for="username">{{$t('system.new_username')}}</label>
                            <input id="username" class="form-control" v-model="username" type="text" required/><br/>
                            <label for="email">{{$t('system.email')}}</label>
                            <input id="email" class="form-control" v-model="email" type="text" required/><br/>
                        </template>
                        <label for="password">{{$t('system.password')}}</label>
                        <b-form-input id="password" :state="password !== ''" class="form-control" v-model="password" type="password"/>
                        <b-form-invalid-feedback>
                          {{ $t('errors.password_must_not_empty') }}
                        </b-form-invalid-feedback>
                        <br/>
                        <label for="password2">{{$t('system.confirm_password')}}</label>
                        <b-form-input :state="password==password2" id="password2" class="form-control" v-model="password2" type="password"/>
                        <b-form-invalid-feedback>
                          {{ $t('errors.password_must_match') }}
                        </b-form-invalid-feedback>
                        <button class="btn btn-outline-primary pull-right" type="submit"><i
                                class="fa fa-sign-in" aria-hidden="true"> </i> {{$t('system.save')}}
                        </button>
                    </div>
                </b-form>
            </b-jumbotron>
            <b-alert v-if="token_valid === false" show variant="danger">Token nicht gültig!</b-alert>
        </loading>
    </div>
</template>

<script>
    import AccountService from '@/api-services/account.service'
    import {EventBus} from '@/eventbus';
    import Loading from "../../components/Loading";

    export default {
        name: "TokenPassword",
        components: {Loading},
        data() {
            return {
                token_valid: null,
                username_set: true,
                username: null,
                email: null,
                password: '',
                password2: '',
            }
        },
        async mounted() {
            let res = await AccountService.check_token_validity(this.$route.params.token)
            this.username = res.data.username
            this.email = res.data.email
            this.username_set = this.username != null
            this.token_valid = res.data.valid
        },
        methods: {
            reset_pw: async function (ev) {
                ev.preventDefault()
                if (this.password == this.password2) {
                    if (!this.username_set) {
                        if(!this.username || this.username.trim() === '') {
                          EventBus.$emit('alert', {
                            variant: 'danger',
                            message: this.$t('errors.invalid_username')
                          })
                          return
                        }
                      let response = await AccountService.set_username_and_password_with_token(this.$route.params.token, this.email, this.username, this.password)
                        if (!response.data.email_verified) {
                            EventBus.$emit('alert', {
                                variant: 'warning',
                                message: "We've send an email to '" + self.email + "' in order to verify the address. Please check your inbox."
                            })
                            this.$emit('alert', {
                                variant: 'warning',
                                message: "We've send an email to '" + self.email + "' in order to verify the address. Please check your inbox."
                            })
                        }
                        this.$router.push('/account')
                    } else {
                        AccountService.reset_password_with_token(this.$route.params.token, this.password).then(() => {
                            EventBus.$emit("alert", {variant: 'success', message: 'Password updated.'})
                            this.$emit("alert", {variant: 'success', message: 'Password updated.'})
                            this.$router.push('/account')
                        })
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
